/**
 * Évolution Mensuelle : Findings / Actions (axe gauche) et TIF (axe droit,
 * échelle différente car le volume d'heures TIF est bien supérieur au
 * nombre de Findings/Actions). Le backend n'inclut jamais de mois futurs
 * par rapport à la date du jour.
 */
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CHARTS } from "@/constants/testIds";

const MONTH_LABELS = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"];

export default function MonthlyEvolutionChart({ data = [] }) {
  const chartData = data.map((d) => ({ ...d, label: MONTH_LABELS[d.month - 1] }));
  return (
    <Card data-testid={CHARTS.monthlyEvolution} className="border-slate-200 shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold uppercase tracking-wider text-slate-500">Évolution Mensuelle</CardTitle>
      </CardHeader>
      <CardContent className="h-[280px] pt-0">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData} margin={{ left: -10, right: 4 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#64748B" }} />
            <YAxis
              yAxisId="left"
              tick={{ fontSize: 11, fill: "#64748B" }}
              label={{ value: "Findings / Actions", angle: -90, position: "insideLeft", fontSize: 10, fill: "#94A3B8" }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              tick={{ fontSize: 11, fill: "#EF4444" }}
              label={{ value: "TIF (h)", angle: 90, position: "insideRight", fontSize: 10, fill: "#EF4444" }}
            />
            <Tooltip contentStyle={{ borderRadius: 8, borderColor: "#E2E8F0", fontSize: 12 }} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Line yAxisId="left" type="monotone" dataKey="findings" name="Findings" stroke="#0B5394" strokeWidth={2} dot={false} />
            <Line yAxisId="left" type="monotone" dataKey="actions" name="Actions" stroke="#F59E0B" strokeWidth={2} dot={false} />
            <Line yAxisId="right" type="monotone" dataKey="tif" name="TIF (h)" stroke="#EF4444" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
